/* eslint-disable jsx-a11y/anchor-is-valid */
import { Card } from "@mui/material"
import TextField from '@mui/material/TextField'
import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import config from '../../../../config.json'
import { login } from '../redux/AuthCRUD'
import * as auth from '../redux/AuthRedux'
import { decryptData } from './util'
//import Log from '../../../../guiLogs/logs/Log'
//import IdleTimerContainer from './IdleTimerContainer'


const loginSchema = Yup.object().shape({
  username: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('Username is required'),
    password: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(20, 'Maximum 20 characters')
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
    //   'Password should contain at least one uppercase letter, one lowercase letter, and one number')
    .required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
}


export function Login() {
  let intervalId: string | number | NodeJS.Timeout | undefined;
  const salt = process.env.SALT || '6d090796-ecdf-11ea-adc1-0242ac112345';
  const clientId = localStorage.getItem('clientId')
  const alertMobileNum = localStorage.getItem('alertMobileNum')
  const encryptedMfaMode = localStorage.getItem('mfaMode');
  const encryptedUsername = localStorage.getItem('username');
  const encryptedEmailId = localStorage.getItem('ccEmail');
  const numberOfDigits=config.OTP_LENGTH_LOGIN;
  const numberOfRetries=config.OTP_Max_Retries;
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [urltoken, setUrltoken] = useState<string>("");
  const [urlusername, setUrlusername] = useState('');
  const [loading, setLoading] = useState(false)
  const [clicked, setClicked] = useState(false);
  const [otpResent, setOtpResent] = useState(false)
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResendLink, setShowResendLink] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);
  const [user, setUser] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [newpass, setNewpass] = useState('');
  const [confirmpass, setConfirmpass] = useState('');
  const [linkExpirationMsg, setLinkExpirationMsg] = useState('');
  const [resetSucc, setResetSucc] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState([false,'']);
  const [confirmPasswordError, setConfirmPasswordError] = useState([false,'']);
  const [inactiveStatus, setInactiveStatus] = useState(false);
  const [sessionexpired, setSessionexpired] = useState('');
  const [displayMessage,setDisplayMessage] = useState("Are you sure you want to change the Password?");
  const [displayDivMessageFont,setDisplayDivMessageFont] = useState("black");
  const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
  const [accesstokenlogin, setAccesstokenlogin] = useState('');
  const [displayExpiryMin, setDisplayExpiryMin] = useState<number>(0);
  const [maskedemailid, setMaskedemailid] = useState('');
  const [sessionTimeoutMessage, setSessionTimeoutMessage] = useState('');
  const [verifyOtp, setVerifyOtp] = useState(false);
  const otpBoxReference = useRef<HTMLInputElement[]>([]);
  const basicAuth = 'Basic ' + btoa(`${config.API_USERNAME}:${config.API_PASSWORD}`);
  var decryptedclientID='',decryptedmobNum = '',decryptedexpiryMin=0,expireTimeDiff=0,expiryMin=0,mfaMode=0,userName='',emailID='',defaultCountDownResendOTP=0;
  const errorTimeout = config.ErrorTimeout;
  const succTimeout = config.SuccessTimeout;
  const expiryMinutes = config.STATUS_EXPIRE_MIN;
  const twoStepAuthSystemWise = config.TWO_STEP_AUTHENTICATION;
  const otp_resend_Interval = config.OTP_Resend_Interval_Attempts;
  const [countdown, setCountdown] = useState(0);
  const [showReturnToLoginOtpPage,setShowReturnToLoginOtpPage] = useState(false);
  const [showResendOTPInterval, setShowResendOTPInterval] = useState(false);
  const dispatch = useDispatch()
  const token = localStorage.getItem('paramValue');
  var decryptedToken = '';
  if(clientId){
    decryptedclientID = decryptData(clientId, salt);
    decryptedmobNum = decryptData(alertMobileNum, salt);
    mfaMode = decryptData(encryptedMfaMode,salt);
    userName= decryptData(encryptedUsername,salt);
    emailID = decryptData(encryptedEmailId,salt);
    decryptedToken = decryptData(token,salt);
  }
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      localStorage.clear();
      setInactiveStatus(false)
      setLoading(true)
      setTimeout(() => {
        login(values.username, values.password)
          .then(({data: {accessToken}}) => {
            setLoading(false)
            if(accessToken)
            {
              setAccesstokenlogin(accessToken)
              const twoStepAuth = localStorage.getItem('twoStepAuth');
                var otpsent = localStorage.getItem('otpsent');
                const decryptedtwoStepAuth = decryptData(twoStepAuth, salt);
                const decryptedotpsent = decryptData(otpsent, salt);
               if(twoStepAuthSystemWise == '1') {
                if(decryptedtwoStepAuth == '1' && decryptedotpsent!= '-2')
                  {
                    setVerifyOtp(true);
                    localStorage.setItem('otpResendAttempt',"0");
                    setShowReturnToLoginOtpPage(false);

                  }
                  else if(decryptedtwoStepAuth == '1' && decryptedotpsent == '-2') {
                    setStatus('Alert Mobile number not Configured')
                    setSubmitting(false)
                  } 
                  else {
                    dispatch(auth.actions.login(accessToken))
                    setIsLoggedIn(true);
                  }
               } else {
                dispatch(auth.actions.login(accessToken))
                setIsLoggedIn(true);
               } 
            }
          })
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            var clientStatus = localStorage.getItem('clientStatus');
            const expiryMinString = localStorage.getItem('expiryMin');
            if (expiryMinString !== null) {
               expiryMin = parseInt(expiryMinString);
            }
            var decryptedclientStatus = '';
            if(clientStatus){
              decryptedclientStatus = decryptData(clientStatus, salt);
            }
            else {
              setStatus('Internal Server Calling Failed')
            }
            if(decryptedclientStatus == '2' || decryptedclientStatus == '3')
            {
              setInactiveStatus(true)
              expireTimeDiff = expiryMinutes - expiryMin;
              setDisplayExpiryMin(expireTimeDiff)
              const intervalId = setInterval(updateExpireTime, 60000);
            }
            else if(decryptedclientStatus == '-1'){
              setStatus('Invalid credentials')
              localStorage.clear();
            }
            else if(decryptedclientStatus == '-2') {
              setStatus('Username does not exist')
              localStorage.clear();
            }
            else {
              setStatus('Internal Server Calling Failed')
            }
          })
          .finally(() => {
      setTimeout(() => {
          setStatus('');
      }, errorTimeout); 
  });
      }, 1000)
    },
  })
  function updateExpireTime() {
    expireTimeDiff--;
    if(expireTimeDiff == 0){
      setInactiveStatus(false);
    }
    setDisplayExpiryMin(expireTimeDiff);
   }

   function updateResendCountDown() {
    const otpResendAttempt = parseInt(localStorage.getItem('otpResendAttempt') || '0', 10);
    //setShowResendOTPInterval(true);
    
      defaultCountDownResendOTP--;
    
    if(defaultCountDownResendOTP == 0 && otpResendAttempt < numberOfRetries) {
        setShowResendOTPInterval(false);
        clearInterval(intervalId);
    } else if (defaultCountDownResendOTP == 0 && otpResendAttempt == numberOfRetries) {
      clearInterval(intervalId);
      setShowResendOTPInterval(false);
      setShowReturnToLoginOtpPage(true);
    }
    setCountdown(defaultCountDownResendOTP);
   }
   
   const getResendInterval = (ResendAttempt: number) => {
    const configItem = otp_resend_Interval.find((item: { attempt: string | null }) => item.attempt == ResendAttempt.toString());
    return configItem ? parseInt(configItem.interval, 10) : 30; 
  };

  useEffect(() => {
    const storedSessionTimeoutMessage = localStorage.getItem('sessionTimeoutMessage');
    if (storedSessionTimeoutMessage) {
      setSessionTimeoutMessage(storedSessionTimeoutMessage);
      localStorage.removeItem('sessionTimeoutMessage');
    }
    setTimeout(() => {
      setSessionTimeoutMessage('');
  }, errorTimeout); 
  }, []);

  const checkOTP = async() => {
    setClicked(true);
    var otptype='1';
    const enteredOTP = otp.join("");
    if(enteredOTP == "")
    {
      setAlertMsg("Please enter the OTP sent to your phone number")
          setTimeout(() => {
            setAlertMsg('');
        }, errorTimeout);
        setClicked(false);
      return false;
    }
    try {
      const formData = new FormData();
      formData.append('clientId',decryptedclientID);
      formData.append('otptype',otptype);
      formData.append('token',decryptedToken);

      const response = await fetch(`${config.apiUrl}/bmpportal/getOTP`,{
        method: 'POST',    
        headers: {
          'Authorization': basicAuth,
        },
        body:formData
      });
      if (response.ok) {
          const apiGeneratedOTP = await response.text();
          if (enteredOTP === apiGeneratedOTP) {
             dispatch(auth.actions.login(accesstokenlogin))
          } else {
            setAlertMsg("OTP did not match. Please Enter the correct OTP")
            setTimeout(() => {
              setAlertMsg('');
          }, errorTimeout);
          setClicked(false);
          }
      } else {
          //console.error('Failed to fetch OTP from API');
      }
  } catch (error) {
      //console.error('Error fetching OTP:', error);
  }
  }

  function handleChange(value: string, index: number) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if(value && index < numberOfDigits-1){
      otpBoxReference.current[index + 1].focus()
    }
  }

  function handleBackspaceAndEnter(e: React.KeyboardEvent<HTMLInputElement>, index: number) {
    if(e.key === "Backspace" && !(e.target as HTMLInputElement).value && index > 0){
      otpBoxReference.current[index - 1].focus()
    }
    if(e.key === "Enter" && (e.target as HTMLInputElement).value && index < numberOfDigits-1){
      otpBoxReference.current[index + 1].focus()
    }
  }

  const resendOTP = async() => {
    const otpResendAttempt = parseInt(localStorage.getItem('otpResendAttempt') || '0', 10);
    let newresendAttempt = otpResendAttempt+1;
    localStorage.setItem('otpResendAttempt',newresendAttempt.toString());
    if(newresendAttempt <= numberOfRetries) {
      defaultCountDownResendOTP = getResendInterval(newresendAttempt);
      setShowResendOTPInterval(true);
      setCountdown(defaultCountDownResendOTP);
      clearInterval(intervalId);
      intervalId = setInterval(updateResendCountDown, 1000);
    } else {
        setShowReturnToLoginOtpPage(true);
    }
    var otptype='1';
    try {
        let url="";
        const formData = new FormData();
        formData.append('clientId',decryptedclientID);
        formData.append('otptype',otptype);
        formData.append('username',userName);
        formData.append('mfaMode',mfaMode);
        formData.append('emailId',emailID);
        formData.append('token',decryptedToken);
      url =`${config.apiUrl}/bmpportal/ResendOTPLogin`; 
      const response = await fetch(url,
      {
        method: 'POST',    
        headers: {
          'Authorization': basicAuth,
        },
        body:formData
      });
      if (response.ok) {
        setOtpResent(true)
      } else {
          //console.error('Failed to fetch OTP from API');
      }
  } catch (error) {
      //console.error('Error fetching OTP:', error);
  }
}

  useEffect(() => {
    if (queryParams.has('resetToken')) {
      const newToken = queryParams.get('resetToken');
      handlesetUrltoken(newToken);
    }
  }, [location.search]);

  // const handlesetUrltoken = (newValue: string | null) => {
  //   setUrltoken(newValue || "");
  // };

  const handlesetUrltoken = async (newValue: string | null) => {
    var clientId ='', usedToken = '',token='';
    const response = await fetch(`${config.apiUrl}/bmpportal/verifyResetToken?token=${newValue}`,
    {
      method: 'GET',    
      headers: {
        'Authorization': basicAuth,
      },
    });
      const responseData = await response.json();
      if (Array.isArray(responseData) && responseData.length > 0) {
        const firstItem = responseData[0];
        clientId = firstItem.clientId;
        usedToken = firstItem.usedToken;
        token = firstItem.token;
      }
      if(token && usedToken == '0'){
        setUrltoken(newValue || "");
        setInvalidToken(false);
      }
      else if(token && usedToken == '1') {
        setUrltoken(newValue || "");
        setInvalidToken(true);
        setLinkExpirationMsg('Token is Already Used')
      }
      else {
        setUrltoken(newValue || "");
        setInvalidToken(true);
        setLinkExpirationMsg('Email link for password reset is expired, Please try again')
      }
  };

  const changeDiv = () => {
    setShowForgotPassword(!showForgotPassword);
  };

  const changeDivtoresendlink = () => {
    setShowForgotPassword(true);
    setShowResendLink(false);
  };
  const ShowLoginDiv = () => {
    setShowForgotPassword(false);
  }

  const returnToLogin = () => {
     setShowForgotPassword(false);
     setUrltoken('');
    <Link to='/auth/login'></Link>
     history.push('/auth/login')  
  }

  const returnToLoginfromserendlink = () => {
    setShowForgotPassword(false);
    setShowResendLink(false)
  }

  const returnToLoginFromOTPPage = () => {
    setShowForgotPassword(false);
    setShowResendLink(false)
    setVerifyOtp(false);
  }
  const handleUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setUser(input);
  };
  
  function isPasswordValid(password: string) {
    const lengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$*()_+=\[\]{}|;:,.?\\-]{8,20}$/;
    return lengthRegex.test(password);
}

  const resetNewPassword = () => {
    if(newpass== '' && confirmpass == '') {
      setNewPasswordError([true,'Enter New Password']);
      setConfirmPasswordError([true,'Enter Confirm Password'])
      return false;
    }
    else if(newpass!= '' && confirmpass == '') {
      setConfirmPasswordError([true,'Enter Confirm Password'])
      return false;
    }
    else if(newpass== '' && confirmpass != ''){
      setNewPasswordError([true,'Enter New Password']);
      return false;
    }
    else if(!isPasswordValid(newpass) && !isPasswordValid(confirmpass)) {
      setNewPasswordError([true, "Invalid New Password (<, &, %, /, \", ', ^ are not allowed)"]);
      setConfirmPasswordError([true,"Invalid Confirm Password(<, &, %, /, \", ', ^ are not allowed)"])
      return false;
    }
    else if(isPasswordValid(newpass) && !isPasswordValid(confirmpass)) {
      setConfirmPasswordError([true,"Invalid Confirm Password(<, &, %, /, \", ', ^ are not allowed)"])
      return false;
    }
    else if(!isPasswordValid(newpass) && isPasswordValid(confirmpass)) {
      setNewPasswordError([true,"Invalid New Password(<, &, %, /, \", ', ^ are not allowed)"]);
      return false;
    } 
    else if(newpass != confirmpass)
    {
      setNewPasswordError([true,'Passwords not matching']);
      setConfirmPasswordError([true,'Passwords not matching'])
      return false;
    }
    $('#ConfirmationModal').modal('show');       
  }

  const callResetAPI = () => {
    $('#ConfirmationModal').modal('hide');
    const formData = new FormData();
    formData.append('Token',urltoken);
    formData.append('Password',confirmpass);
    const url = `${config.apiUrl}/bmpportal/changePassword`;
     fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': basicAuth,
        //'Content-Type': 'application/json',  
      },
      body:formData
    })
      .then(response => response.json())
      .then(data => {
        ////console.log(data);
        if(data == '-2') {
        //      setAlertMsg("Invalid Link or the link has been expired")
        //        setTimeout(() => {
        //     setAlertMsg('');
        // }, succTimeout);  
             setResetSucc('0')
        } else if(data == '-3') {
    //       setAlertMsg("Token is already expired")
    //         setTimeout(() => {
    //      setAlertMsg('');
    //  }, succTimeout);  
          setResetSucc('0')
     }
        else {
        setResetSucc('1')
       }
      })
      .catch(error => {
        setAlertMsg("Reset Password Unsuccesfull")
               setTimeout(() => {
            setAlertMsg('');
        }, succTimeout);  
        ////console.error('Error:', error);
      });
  }
  const newPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewPasswordError([false,'']);
    const input = event.target.value;
    setNewpass(input);
  }

  const confirmPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPasswordError([false,''])
    const input = event.target.value;
    setConfirmpass(input);
  }

  
  const sendLink = () => {
    setClicked(true);
    if(user == "")
    {
      setAlertMsg("Please Enter the Username")
          setTimeout(() => {
            setAlertMsg('');
        }, errorTimeout);
      setClicked(false);
      return false;
    }
    fetch(`${config.apiUrl}/bmpportal/sendEmail`, {
        method: 'POST',
        headers: {
          'Authorization': basicAuth,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 'username':user}),
      })
      .then(response => {
        if (response.ok) {
          return response.json(); 
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      })
      .then(data => {
        var res = data.data;
        const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
        if(res == '-1')
        {
          setAlertMsg("User Name does not Exist")
          setTimeout(() => {
            setAlertMsg('');
        }, errorTimeout); 
          return false;
        }
        else if(res == '-2')
        {
          setAlertMsg("Alert Email Id not configured")
          setTimeout(() => {
            setAlertMsg('');
        }, errorTimeout);
          return false;
        }
        if(emailPattern.test(res))
        {
          setShowResendLink(true)
          const maskedEmail = maskEmail(res);
          setMaskedemailid(maskedEmail);
        }
      })
        .catch(error => {
          //console.error('Error:', error);
        })
        .finally(() => {
        setClicked(false);
      });
  }

  function maskEmail(email: string) {
    const atIndex = email.indexOf('@');
    const beforeAtIndex = email.slice(0, atIndex);
    let maskedPart='';
    if (beforeAtIndex.length <= 3) {
      maskedPart = '*'.repeat(atIndex - 1) + email.slice(atIndex - 1, atIndex);
    }
    else {
      maskedPart = '*'.repeat(atIndex - 4) + email.slice(atIndex - 4, atIndex);
    }
    //const maskedPart = '*'.repeat(atIndex - 4) + email.slice(atIndex - 4, atIndex);
    return maskedPart + email.slice(atIndex);
}

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleImageLoad = () => {
      setIsLoaded(true);
    };

    const imageElements = document.querySelectorAll('.login-image');
    imageElements.forEach((image) => {
      image.addEventListener('load', handleImageLoad);
    });

    return () => {
      imageElements.forEach((image) => {
        image.removeEventListener('load', handleImageLoad);
      });
    };
  }, []);

  useEffect(() => {
    if (isLoaded) {
      const loginDiv = document.getElementById('logindiv');
      if (loginDiv) {
        loginDiv.style.display = 'block';
      }
    }
  }, [isLoaded]);

 //------------------------------
 const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  setInactiveStatus(false);
  formik.handleChange(event);
};

const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  setInactiveStatus(false);
  formik.handleChange(event);
};

  return (
  <> 
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundColor: '#f4f4f4', 
      }}
    >
     
    <div className='d-flex justify-content-center mt-4' id="login-container" >
    <div id='logindiv' style={{ display: 'none' }}>
    <Card sx={{ minWidth: '100%',minHeight:'100%', margin: "0 auto", mt: 0,transform:'scale(0.9)',marginTop:'-30px'}}>
      <a href='#'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-dhiraagu-02.svg')} className='h-40px radius-10' />
           </a>
    <div className='col-lg-12'>
    <div className='row text-start'>
    <div className='col-lg-6'>  
        <img src={toAbsoluteUrl('/media/logos/loginscreen.png')} alt='Login' className='img-fluid login-image' style={{height:'100%',width:'100%'}}/>
    </div>
    
    <div className='col-lg-6 p-10 p-lg-15 ml-5'>
    <div className='d-flex align-items-center rounded-lg p-4' style={{alignItems: 'center',display:'flex',justifyContent:'center'}}>
    <a href='#' >
      <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-dhiraagu-02.svg')} className='h-30px radius-10' />
    </a>
    <h1 className='ml-2 mb-0 fs-6'>&nbsp;&nbsp;&nbsp;&nbsp;| &nbsp;&nbsp;<a href='#' >
      <img alt='Logo' src={toAbsoluteUrl('/media/logos/Bulk_message.svg')} className='h-20px radius-10' />
    </a></h1>
  </div>
  <br />

  {/* Login Div*/}
  <div id="logindiv" style={{ display: !showForgotPassword && !verifyOtp && urltoken === '' ? 'block' : 'none' }}>
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'>
        {sessionTimeoutMessage?(<div className='mb-lg-10'>
          <div className='alert-text font-weight-bold' style={{color:'Red',fontWeight:'bold',textAlign:'center',fontSize:'16px'}}>{sessionTimeoutMessage}</div>
        </div>):(<p>{}</p>)}
       {formik.status? (
        <div className='mb-lg-10'>
          <div className='alert-text' style={{color:'Red',fontWeight:'bold',textAlign:'center',fontSize:'16px'}}>{formik.status}</div>
        </div>
      ) : (<p></p>)}
      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <input
          placeholder='Username'
          {...formik.getFieldProps('username')}
          onChange={handleUserNameChange}
          className={clsx(
            {'is-invalid': formik.touched.username && formik.errors.username},
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off' maxLength={20}
          style={{border: 'none',borderBottom: '2px solid skyblue',padding: '5px',width: '100%',outline: 'none', background: 'transparent'}}
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.username}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
         
        </div>
        <input
          type='password' placeholder='Password'
          autoComplete='off' maxLength={20}
          {...formik.getFieldProps('password')}
          onChange={handlePasswordChange}
          className={clsx(
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
          style={{border: 'none',borderBottom: '2px solid skyblue',padding: '5px',width: '100%',outline: 'none', background: 'transparent'}}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block' style={{position:'absolute',transform:'scale(0.97)'}}>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
       <p style={{textAlign:'center', display:inactiveStatus?'block':'none'}}><strong>Your Account is temporarily Suspended <br /> Please try again in {displayExpiryMin} minutes</strong></p>
      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg w-100 mb-5 mt-4'
          style={{backgroundColor:'#FF5733', color: 'white'}}>
          {!loading && <span className='indicator-label'>Sign In</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        <div className='d-flex flex-stack mb-2 justify-content-center text-center mb-2'>
           <p>Forgot Password?
           <span
                className='link-primary fs-6 fw-bolder'
                style={{ marginLeft: '5px', color: 'black', cursor: 'pointer' }}
                onClick={changeDiv} >
                Click Here
              </span>
          </p>
         </div>
       </div>
         <div className='d-flex flex-stack mb-2 justify-content-center text-center mt-4'>
           {/*<p>Don't have an account?
           <Link
             to='/auth/forgot-password'
             className='link-primary fs-6 fw-bolder'
             style={{marginLeft: '5px',color:'black'}}>
             Sign up
           </Link>
          </p>*/}
          <div className='mt-20'></div>
          </div> 
          </form>
      </div> 


      {/* Forgot Password*/}
      <div id="forgotpassdiv" style={{ display: showForgotPassword && urltoken === ''? 'block' : 'none' }}>
      <div id="SendLink" style={{display: !showResendLink?'block':'none'}}>
        <h1 style={{textAlign:'center'}}>Forgot your Password?</h1>
        <br />
        {alertMsg? (
        <div className='mb-lg-10'>
          <div className='alert-text' style={{color:'Red',fontWeight:'bold',textAlign:'center',fontSize:'14px'}}>{alertMsg}</div>
        </div>
      ) : (<p></p>)}
        <p style={{ color: '#111111' ,textAlign:'center'}}><strong>Enter your user name below and we will send a link to<br />
        reset your password to the registered email address</strong></p>
        <br />
        <input
          placeholder=' Enter Username' onChange={handleUserName} style={{border: 'none',borderBottom: '2px solid skyblue',padding: '5px',width: '100%',outline: 'none', background: 'transparent'}} />
        <br /><br />
        <button className='btn btn-lg w-100 mb-5'
          style={{backgroundColor:'#FF5733', color: 'white',transition: 'opacity 0.5s ease',opacity: clicked ? 0.5 : 1}} onClick={sendLink}>Send Link</button>
          <br />
          <span className='link-primary fs-6 fw-bolder mb-5' onClick={ShowLoginDiv} 
                style={{
                  marginLeft: '5px',
                  color: 'black',
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: 'block',  
                  margin: 'auto', 
                  marginBottom:'5px'  
                }}>
                Return to login
              </span>
            
          </div>
              <div id="ResendLink" style={{display: showResendLink?'block':'none'}}>
                 <h1 style={{textAlign:'center'}}>Email Sent!</h1>
                 <br />
                 <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}><img alt='Logo' src={toAbsoluteUrl('/media/logos/Email.svg')} className='h-60px radius-10' /></div>
                <br />
                <p style={{ color: '#111111' ,textAlign:'center'}}><strong>Hello, {user} </strong></p>
                <br />
                 <p style={{ color: '#111111' ,textAlign:'center'}}><strong>We have sent a email to {maskedemailid} with a <br /> link to reset your Password </strong></p>
                <br />
                <div className='d-flex flex-stack mb-2 justify-content-center text-center mb-2'>
               <p>Didn't recieve the link? <span
                className='link-primary fs-6 fw-bolder'
                style={{ marginLeft: '5px', color: 'black', cursor: 'pointer' }}
                onClick={changeDivtoresendlink} >
                Resend
              </span>
          </p>
         </div>
                <span className='link-primary fs-6 fw-bolder' onClick={returnToLoginfromserendlink}
                style={{
                  marginLeft: '5px',
                  color: 'black',
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: 'block',
                  margin: 'auto',
                }}>
                Return to login
              </span>
              </div>

      </div>



       {/* Otp verification */}
      <div id="otpVerifydiv" style={{ display: verifyOtp? 'block' : 'none'}} >
        <h1 style={{textAlign:'center',display: !otpResent? 'block' : 'none'}}>Verify its you</h1>
        <h1 style={{textAlign:'center',display: otpResent? 'block' : 'none'}}>OTP Resent! Verify its you</h1>
        <br />
        {alertMsg? (
        <div className='mb-lg-10'>
          <div className='alert-text' style={{color:'Red',fontWeight:'bold',textAlign:'center',fontSize:'14px'}}>{alertMsg}</div>
        </div>
      ) : (<p></p>)}
      {mfaMode == 1 && 
         <p style={{ color: '#111111' ,textAlign:'center' }}>Please enter the <strong>OTP</strong> sent to your 
        phone number <br /><strong>{decryptedmobNum}</strong> via text message</p>
      } 
      {mfaMode == 2 &&
         <p style={{ color: '#111111' ,textAlign:'center' }}>Please enter the <strong>OTP</strong> sent to your 
        email <br /><strong>{emailID}</strong></p>
      }
        
        <br />
      <div className="otp-input-container gap-3" style={{ display: 'flex', justifyContent: 'center' }}>
      {otp.map((digit, index)=>(
        <input key={index} value={digit} maxLength={1} 
        style={{width:'3em',textAlign: 'center',height:'3em',borderRadius: '0.5em',border: '1px solid #ccc'}} 
        onChange={(e)=> handleChange(e.target.value, index)}
        onKeyUp={(e)=> handleBackspaceAndEnter(e, index)}
        ref={(reference) => (otpBoxReference.current[index] = reference as HTMLInputElement)}
        />
      ))}

     </div>
        <br /><br />
        <button className='btn btn-lg w-100 mb-5'
          style={{backgroundColor:'#FF5733', color: 'white',transition: 'opacity 0.5s ease',opacity: clicked ? 0.5 : 1}} onClick={checkOTP}>Verify</button>
          <br /><br />
          <div className='d-flex flex-stack mb-2 mt-2 justify-content-center text-center mb-2'>
          {(!showResendOTPInterval && !showReturnToLoginOtpPage) &&
             <p>Didn't receive your code? <span
             className='link-primary fs-6 fw-bolder'
             style={{ marginLeft: '5px', color: 'black', cursor: 'pointer' }} onClick={resendOTP}>
             Resend</span>
        </p>
          }
          {showResendOTPInterval &&
             <p style={{color:'red'}}>Resend Code in {countdown} seconds</p>
          }
          {showReturnToLoginOtpPage &&
              <span className='link-primary fs-6 fw-bolder'
              onClick={returnToLoginFromOTPPage}
              style={{
                marginLeft: '5px',
                color: 'black',
                cursor: 'pointer',
                textAlign: 'center',
                display: 'block',
                margin: 'auto',
              }}>
              Return to login
            </span>
          }
           
          </div>
      </div>

     
      {/* Reset Password*/}
      <div id="resetPass" style={{ display: urltoken !== '' && !invalidToken ? 'block' : 'none' }}>
      <h1 style={{textAlign:'center'}}>Reset Password</h1>
      <br />
      {alertMsg? (
        <div className='mb-lg-10'>
          <div className='alert-text' style={{color:'Red',fontWeight:'bold',textAlign:'center',fontSize:'14px'}}>{alertMsg}</div>
        </div>
      ) : (<p></p>)}
      <div id="beforeReset" style={{display: resetSucc == '1'?'none':'block'}}>
        <p style={{ color: '#111111' ,textAlign:'center' }}>your Password must be at least 8 characters including a <br /> lowercase letter, an uppercase letter, and a number</p>
        <br />
        <div style={{textAlign:'center'}}>
        <TextField  type="password" style={{ width: '65%',margin: 'auto' }} label={newPasswordError[0] == false? "Enter new password":newPasswordError[1]} error={typeof newPasswordError[0] ==='boolean'?newPasswordError[0]:undefined} placeholder="Enter new password" onChange={newPassword} InputLabelProps={{
       shrink: true,
     }} inputProps={{maxLength: 20 }}/>
     
        </div>
        <br />
        <div style={{textAlign:'center'}}>
        <TextField type="password" style={{ width: '65%',margin: 'auto' }} label={confirmPasswordError[0]== false?"Confirm new password":confirmPasswordError[1]} error={typeof confirmPasswordError[0] ==='boolean'?confirmPasswordError[0]:undefined} placeholder="Enter new password" onChange={confirmPassword} InputLabelProps={{
       shrink: true,
     }} inputProps={{maxLength: 20 }}/>
       </div>
       <br />
        <button className='btn btn-lg w-100 ml-5' onClick={resetNewPassword}
          style={{backgroundColor:'#FF5733', color: 'white'}}>Reset Password</button>
          </div>

          <div id="afterReset" style={{display: resetSucc == '1'?'block':'none'}}>
            <br />
            <p style={{ color: '#111111' ,textAlign:'center' }}>Your Password has been reset Successfully</p>
            <br />
            <span className='link-primary fs-6 fw-bolder' onClick={returnToLogin}
                style={{
                  marginLeft: '5px',
                  color: 'black',
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: 'block',
                  margin: 'auto',
                }}>
                Return to login
              </span>

           <br /><br /><br /><br /><br /><br /><br /><br /><br />
          </div>
      </div>

      {/*Invalid Link in Reset Passwod Case */}
      <div id="resetPassInvalid" style={{ display: urltoken !== '' && invalidToken ? 'block' : 'none' }}>
      <br /><h1 style={{textAlign:'center'}}>Request Expired</h1><br /><br />
      <p style={{ color: '#111111' ,textAlign:'center' }}>{linkExpirationMsg}</p>
        <br /><br/>
        <span className='link-primary fs-6 fw-bolder' onClick={returnToLogin}
                style={{
                  marginLeft: '5px',
                  color: 'black',
                  cursor: 'pointer',
                  textAlign: 'center',
                  display: 'block',
                  margin: 'auto',
                }}>
                Return to login
              </span><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      </div>
      {/* end::Action */}
    
    <div className='row' style={{position:'relative'}}> 
         <div className='mt-15'></div>
         </div>
         <div className='mb-0 mt-20' style={{alignItems: 'center',display:'flex',justifyContent:'center'}}>
         <p className='fs-6 mb-0'>
            <a href={config.learnmoreurl} className='link-primary' target="_blank" style={{ marginRight: '10px', fontSize: '10px',color:'black'}}>
              Learn More
            </a>
            | <a href={config.tearmsconditionsurl} className='link-primary' target="_blank" style={{ marginRight: '10px', fontSize: '10px' ,color:'black'}}>
               Terms & Conditions
            </a>
            | <a href={config.contactLink} className='link-primary' target="_blank" style={{ marginRight: '10px', fontSize: '10px',color:'black' }}>
              Contact Us
            </a>
         {/*  | <a href='/about' className='link-primary' target="_blank" style={{ fontSize: '10px',color:'black' }}>
               Need help?
            </a> */}
          </p>
          </div>
    </div>
    </div>
    
    </div>
    </Card>
    </div>
    </div> 
   </div>

{/* modal for reset password confirmation*/}
    <div  className={`modal fade ${showModal? 'show':''}`} id="ConfirmationModal" data-bs-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden={!showModal}>
      <div className="modal-dialog modal-dialog-centered mw-600px mh-200px">
        <div className="modal-content">
        <div className="modal-header" >
          <div>
          <h3 className="modal-title" id="staticBackdropLabel" style={{ display: 'flex', alignItems: 'center', width:'600px' }}>
          <div data-bs-dismiss="modal" style={{width:'25px',marginRight: '180px' }}><i className="bi bi-chevron-left" style={{color:'black',fontSize: '25px',cursor:'pointer'}}></i></div>
          Reset Password
          </h3>
          </div>
          </div>
          <div > 
          <div className="modal-body" >
                <div style={{display:"flex",justifyContent:"center",textAlign:"center",marginTop:"-5px",marginBottom:"10px"}}><h4 style={{ color:displayDivMessageFont,fontWeight:"bold"}}>{displayMessage}</h4>
                </div> 
          </div>  
          </div> 
          <div className="modal-footer" style={{ display: 'flex', alignItems: 'center'}}>    
          <button type="button"  className="btn" data-bs-dismiss="modal" style={{marginLeft:"150px",background:'white', borderRadius:'32px', border: '2px solid #F15625',color:'#F15625"'}}>Cancel</button> 
          <div style={{width:'5px'}}></div>
          <button type="button" className="btn" style={{marginRight:"200px",alignItems: 'center',background:'red', borderRadius:'32px', border: '2px solid #F15625',color:'white'}} onClick={callResetAPI}>&nbsp;&nbsp;&nbsp;Ok&nbsp;&nbsp;&nbsp;</button>
          </div>
        </div>
      </div>
    </div> 

    
    </>
  )
}
